(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('PeopleFranchiserListController', PeopleFranchiserListController)

    /** @ngInject */
    function PeopleFranchiserListController($httpParamSerializer, $q, CompanyService, PermissionGroupService, ResponsibilityService, PersonService,
        AuthenticationService, UtilHelper, LoadingHelper, SYSTEM_MODULES, ROUTES, MeService) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;
        let allCompanies = [];

        vm.isSearchDisabled = () => {
            if (vm.selectedPermissionGroup || vm.selectedResponsibility || vm.selectedCompany || (vm.selectedSearchField && vm.searchText))
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedPermissionGroup || vm.selectedResponsibility || vm.selectedCompany || vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;
                vm.isFirstCall = false;
                vm.isLoading = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedCompany = null;
            vm.selectedPermissionGroup = null;
            vm.selectedResponsibility = null;
            vm.selectedSearchField = null;
            vm.searchText = null;
            vm.people = [];
            vm.isFirstCall = true;

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            if (vm.isFirstCall) {
                vm.isLoading = false;
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getPeople(start, number, tableState);
        }

        vm.getCompanies = search => {
            if (!search) {
                vm.companies = [];
                return;
            }

            vm.companies = allCompanies.filter(company => filterCompany(company, search))
        }

        vm.orderPersonResponsibilities = personCompanies => {
            let filteredPersonCompanies = [];

            for (let index = 0; index < personCompanies.length; index++) {
                const personCompany = personCompanies[index];
                let foundFPC = filteredPersonCompanies.find(fpu => (fpu.ResponsibilityId == personCompany.ResponsibilityId));

                if (foundFPC) {
                    foundFPC.Companies.push(personCompany.Unit)
                } else {
                    filteredPersonCompanies.push({
                        ResponsibilityId: personCompany.ResponsibilityId,
                        Responsibility: personCompany.Responsibility,
                        Companies: [personCompany.Company]
                    })
                }
            }

            return filteredPersonCompanies;
        }

        vm.configureReportDownload = () => {
            LoadingHelper.startLoading('.btn-download', true);
            vm.isLoadingDownloadData = true;

            const parameters = prepareParameters(0, 0, null);

            MeService
                .getDownloadToken()
                .then(success => {
                    vm.isLoadingDownloadData = false;
                    LoadingHelper.stopLoading('.btn-download', true);

                    window.open(`${ROUTES.API}/people-report?Token=${success}&${$httpParamSerializer(parameters)}`, '_blank');
                }, error => {
                    vm.isLoadingDownloadData = false;
                    LoadingHelper.stopLoading('.btn-download', true);
                    UtilHelper.errorCallback(error);
                })
        }

        init();

        function getPeople(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            PersonService
                .getByParameters(parameters)
                .then(success => {
                    vm.people = success.Registers;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.people = null;
                    vm.isLoading = false;
                    UtilHelper.errorCallback(error);
                })
        }

        function getPermissionGroups() {
            PermissionGroupService
                .getAll()
                .then(success => {
                    vm.permissionGroups = success.Registers;
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }

        function getResponsibilities() {
            return ResponsibilityService
                .getAll()
                .then(success => {
                    vm.responsibilities = success.Registers;
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }

        function getAllCompaniesResumed() {
            return CompanyService
                .getAllResumed()
                .then(success => {
                    allCompanies = success;
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }

        function filterCompany(company, search) {
            if (company.FantasyName == null)
                company.FantasyName = '';

            if (company.CorporateName == null)
                company.CorporateName = '';

            if (company.UniqueCode == null)
                company.UniqueCode = '';

            if (company.ExternalCode == null)
                company.ExternalCode = '';

            if (company.FantasyName.toLowerCase().includes(search.toLowerCase()) || company.CorporateName.toLowerCase().includes(search.toLowerCase()) || company.UniqueCode.toString().includes(search) || company.ExternalCode.toString().includes(search))
                return company;
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'Name',
                OrderDescending: false
            }

            if (vm.selectedPermissionGroup || vm.selectedResponsibility || vm.selectedCompany || (vm.selectedSearchField && vm.searchText))
                isTableSearch = true;

            if (vm.selectedPermissionGroup)
                params.PermissionGroupId = vm.selectedPermissionGroup.Id;

            if (vm.selectedResponsibility)
                params.ResponsibilityId = vm.selectedResponsibility.Id;

            if (vm.selectedCompany)
                params.CompanyId = vm.selectedCompany.Id;

            if (tableState && tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText)
                params[vm.selectedSearchField.Value] = vm.searchText;

            return params;
        }

        function init() {
            const loggedUserData = AuthenticationService.getUser();

            vm.canUserHandlePerson = AuthenticationService.getCompanyDataByPermissionGroupAndModuleId(loggedUserData.PermissionGroup.Id, SYSTEM_MODULES.FRANCHISER_PEOPLE).length > 0;
            vm.selectedCompany;
            vm.selectedResponsibility;
            vm.selectedPermissionGroup;
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = false;
            vm.isFirstCall = true;

            vm.searchFields = [{
                Value: 'Document',
                Description: 'Documento'
            }, {
                Value: 'Name',
                Description: 'Nome'
            }, {
                Value: 'Email',
                Description: 'E-mail'
            }];

            LoadingHelper.startLoading('.custom-filters');

            $q.all([getPermissionGroups(), getResponsibilities(), getAllCompaniesResumed()])
                .then(() => {
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }
    }
}());